































import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  props: {
    conditions: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const headers = [
      { text: 'ID', value: 'id', width: '10%' },
      { text: '選択肢', value: 'choices', width: '60%' },
      { text: '遷移先', value: 'destinationPage', width: '15%' },
      { text: '操作', value: 'actions', width: '15%', align: 'center' },
    ]
    return { headers }
  },
})
